import React, { useEffect, useRef } from 'react'
import { Option, OptionsList } from './style'
import { Settings, SquarePen, Tag, Zap } from 'lucide-react'

interface PropsType {
  onClose: () => void
  onConfigurePipeline: () => void
  onViewTags: () => void
  onViewAutomations: () => void
}

const PipelineOptionsDropdown: React.FC<PropsType> = ({ onClose, onConfigurePipeline, onViewTags, onViewAutomations }) => {
  const dropdownRef = useRef<HTMLUListElement | null>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [onClose])

  return (
    <OptionsList ref={dropdownRef}>
      <Option onClick={() => {
        onConfigurePipeline()
        onClose()
      }}>
        <SquarePen size={18} /> Campos
      </Option>
      <Option onClick={() => {
        onViewTags()
        onClose()
      }}>
        <Tag size={18} /> Tags
      </Option>
      <Option onClick={() => {
        onViewAutomations()
        onClose()
      }}>
        <Zap size={18} /> Automações
      </Option>
    </OptionsList>
  )
}

export default PipelineOptionsDropdown

